import { ReportSnapshot } from 'dashboard/models/report-snapshot';
import {
  ReportSnapshotActions,
  ReportSnapshotActionType,
} from 'dashboard/redux/actions/report-snapshot';

export interface ReportSnapshotState {
  reportSnapshot: ReportSnapshot | undefined;
}

export const initialState: ReportSnapshotState = {
  reportSnapshot: undefined,
};

const reportSnapshotReducer = (
  state: ReportSnapshotState = initialState,
  action: ReportSnapshotActions,
): ReportSnapshotState => {
  switch (action.type) {
    case ReportSnapshotActionType.SetReportSnapshot: {
      return {
        ...state,
        reportSnapshot: action.payload.reportSnapshot,
      };
    }
    default:
      return state;
  }
};

export default reportSnapshotReducer;
